module.exports = __webpack_public_path__ + "img/ly.ec30faba.png";